import React from "react";
import Seo from "../components/Seo";
import "./ContactsPage.css";

export default function ContactsPage() {
    const company = {
        name: 'ТОО "ИС Qarzhy.kz"',
        bin: "230140028079",
        address: "г. Астана, ул. Ф. Онгарсынова 6/2",
        phone: "+7-701-590-11-88",
        whatsapp: "https://wa.me/77015901188",
        email: "info@qarzhy.kz",
        workingHours: "Пн–Пт, 09:00–18:00",
        description:
            "Компания предоставляет цифровые решения для анализа, сверки и обработки финансовых документов.",
    };

    const organizationJsonLd = {
        "@context": "https://schema.org",
        "@type": "Organization",
        name: "Qarzhy",
        legalName: company.name,
        url: "https://qarzhy.kz",
        email: company.email,
        telephone: company.phone,
        address: {
            "@type": "PostalAddress",
            streetAddress: "ул. Ф. Онгарсынова 6/2",
            addressLocality: "Астана",
            addressCountry: "KZ",
        },
    };

    return (
        <>
            <Seo
                title='Контакты Qarzhy – ТОО "NUBES"'
                description="Контакты сервиса Qarzhy. ТОО NUBES, Астана, телефон, WhatsApp, email, консультации и подключение сервиса автоматизированной сверки платежных поручений."
                keywords="контакты Qarzhy, ТОО NUBES, автоматизированная сверка платежных поручений, контакты сервиса, Астана, WhatsApp, email"
                url="https://qarzhy.kz/contacts"
            >
                <script type="application/ld+json">
                    {JSON.stringify(organizationJsonLd)}
                </script>
            </Seo>

            <div className="contacts-page">
                <section className="contacts-hero-card">
                    <div className="contacts-hero-badge">Контакты</div>

                    <div className="contacts-hero-head">
                        <div>
                            <h1 className="contacts-page__title">{company.name}</h1>

                            <p className="contacts-page__subtitle">
                                Свяжитесь с нами по вопросам подключения, консультации,
                                сопровождения и использования сервиса.
                            </p>
                        </div>
                    </div>
                </section>

                <div className="contacts-main-grid">
                    <section className="contacts-card">
                        <div className="contacts-card-kicker">Компания</div>
                        <h2 className="contacts-card-title">Основная информация</h2>

                        <div className="contacts-info-list">
                            <div className="contacts-info-row">
                                <div className="contacts-info-label">Наименование</div>
                                <div className="contacts-info-value">{company.name}</div>
                            </div>

                            <div className="contacts-info-row">
                                <div className="contacts-info-label">БИН</div>
                                <div className="contacts-info-value">{company.bin}</div>
                            </div>

                            <div className="contacts-info-row">
                                <div className="contacts-info-label">Адрес</div>
                                <div className="contacts-info-value">{company.address}</div>
                            </div>

                            <div className="contacts-info-row">
                                <div className="contacts-info-label">Телефон</div>
                                <div className="contacts-info-value">
                                    <a href={`tel:${company.phone}`} className="contacts-link">
                                        {company.phone}
                                    </a>
                                </div>
                            </div>

                            <div className="contacts-info-row">
                                <div className="contacts-info-label">WhatsApp</div>
                                <div className="contacts-info-value">
                                    <a
                                        href={company.whatsapp}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="contacts-link contacts-link-whatsapp"
                                    >
                                        Написать в WhatsApp
                                    </a>
                                </div>
                            </div>

                            <div className="contacts-info-row">
                                <div className="contacts-info-label">Email</div>
                                <div className="contacts-info-value">
                                    <a href={`mailto:${company.email}`} className="contacts-link">
                                        {company.email}
                                    </a>
                                </div>
                            </div>

                            <div className="contacts-info-row">
                                <div className="contacts-info-label">Режим работы</div>
                                <div className="contacts-info-value">{company.workingHours}</div>
                            </div>
                        </div>
                    </section>

                    <section className="contacts-card">
                        <div className="contacts-card-kicker">О нас</div>
                        <h2 className="contacts-card-title">Описание</h2>

                        <p className="contacts-description">
                            {company.description}
                        </p>

                        <div className="contacts-note">
                            Для подключения сервиса, уточнения условий сотрудничества и получения
                            консультации используйте указанные контактные данные.
                        </div>
                    </section>
                </div>
            </div>
        </>
    );
}